import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { forwardRef } from 'react';
import { classNames } from '../../helpers/classnames.js';
import { useColorInteadOfStatus } from '../../types/status.js';

var Icon = forwardRef(function (_a, ref) {
    var iconName = _a.iconName, _b = _a.size, size = _b === void 0 ? 'medium' : _b, type = _a.type, className = _a.className, contained = _a.contained, color = _a.color, props = __rest(_a, ["iconName", "size", "type", "className", "contained", "color"]);
    // TODO: удалить при удалении пропса type (не забудь указать пропсу color дефолтное значение)
    // при удалении заменить использование iconColor на color
    var iconColor = useColorInteadOfStatus({ color: color, type: type }, 'Icon');
    // TODO: удалить при удалении пропса type
    // при удалении заменить использование isContained на contained
    var isContained = contained || Boolean(type);
    return (React__default.createElement("span", __assign({ "data-testid": "Icon" }, props, { role: "img", className: classNames('beeline-icons', 'dsb_icon', isContained && 'dsb_icon--contained', isContained && "dsb_icon--".concat(iconColor), !isContained && "dsb_icon--".concat(size), !isContained && "dsb_icon--sized--".concat(iconColor), className), ref: ref }), iconName));
});

export { Icon };
